import { useRef } from 'react';
import { processStages } from '@/mocks/site';
import ProcessTrack from './process/ProcessTrack';
import ProcessStage from './process/ProcessStage';
import useProcessTimeline from './process/useProcessTimeline';

export default function Process() {
  const sectionRef = useRef<HTMLElement>(null);
  const viewportRef = useRef<HTMLDivElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);
  const { active, goTo } = useProcessTimeline(processStages.length, {
    section: sectionRef,
    viewport: viewportRef,
    track: trackRef,
  });

  return (
    <section
      id="process"
      ref={sectionRef}
      className="relative bg-[#0B0C10] text-[#F5F5F6] py-16 md:py-20 lg:min-h-screen lg:flex lg:flex-col lg:justify-center lg:py-12 overflow-x-hidden"
    >
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8 lg:px-10">
        <h2 className="font-heading uppercase text-[36px] md:text-[48px] leading-[0.95] mb-6 md:mb-8">How your repair runs</h2>
        <ProcessTrack stages={processStages} active={active} onSelect={goTo} viewportRef={viewportRef} trackRef={trackRef} />
        <div className="mt-6 md:mt-8">
          <ProcessStage stages={processStages} active={active} onSelect={goTo} />
        </div>
      </div>
    </section>
  );
}